import { render, staticRenderFns } from "./xeSelfRateCardSetting.vue?vue&type=template&id=0ca43ef4"
import script from "./xeSelfRateCardSetting.vue?vue&type=script&lang=js"
export * from "./xeSelfRateCardSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports